import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/sfacoctg.jpeg';
import { useLoginModal } from '../components/LoginModalContext';
import { useAuth } from '../context/AuthContext';
import PublicUserMenu from '../components/PublicUserMenu';
import { getDefaultSiteContent, getSiteContent } from '../services/authService';
import './Home.css';
import './PlaceholderPage.css';

export default function Stories() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [siteContent, setSiteContent] = useState(getDefaultSiteContent());
  const { openLogin, openRegister } = useLoginModal();
  const { isAuthenticated, user, logout } = useAuth();

  useEffect(() => {
    getSiteContent()
      .then((data) => setSiteContent(data))
      .catch(() => {});
  }, []);

  return (
    <div className="dashboard">
      <div className="dashboard-topbar">
        <div className="dashboard-topbar-left">
          <span>{siteContent.companyName}</span>
          <span className="dot" />
          <span>{siteContent.topHeaderAddress}</span>
          <span className="dot" />
          <span>{siteContent.topHeaderEmail}</span>
          <span className="dot" />
          <span>{siteContent.topHeaderPhone}</span>
        </div>
        <div className="dashboard-topbar-right">
          <a href={siteContent.linkedinUrl} target="_blank" rel="noreferrer">LinkedIn</a>
          <a href={siteContent.instagramUrl} target="_blank" rel="noreferrer">Instagram</a>
          <a href={siteContent.facebookUrl} target="_blank" rel="noreferrer">Facebook</a>
          <a href={siteContent.whatsappUrl} target="_blank" rel="noreferrer">WhatsApp</a>
        </div>
      </div>

      <header className="dashboard-header">
        <div className="brand">
          <img className="brand-logo" src={siteContent.logoUrl || logo} alt="Safco CTG logo" />
          <div>
            <p className="brand-title">{siteContent.brandTitle}</p>
            <p className="brand-subtitle">{siteContent.brandSubtitle}</p>
          </div>
        </div>
        <nav className={`dashboard-nav ${mobileMenuOpen ? 'open' : ''}`}>
          <Link to="/">Home</Link>
          <Link to="/members">Members</Link>
          <Link to="/stories">Stories</Link>
          <Link to="/about">About</Link>
          <Link to="/contact">Contact</Link>
          <div className="mobile-actions">
            {!isAuthenticated && (
              <>
                <button className="ghost-button" type="button" onClick={openLogin}>Login</button>
                <button className="ghost-button" type="button" onClick={openRegister}>Register</button>
              </>
            )}
            {isAuthenticated && (
              <>
                <Link className="ghost-button" to={user?.role === 'admin' ? '/dashboard/admin' : '/dashboard/member'}>Dashboard</Link>
                <button className="ghost-button" type="button" onClick={logout}>Logout</button>
              </>
            )}
            <Link className="ghost-button" to="/submit-payment">Donate</Link>
            <Link className="solid-button" to="/submit-payment">Submit Payment</Link>
          </div>
        </nav>
        <div className="dashboard-actions">
          {!isAuthenticated && (
            <>
              <button className="ghost-button" type="button" onClick={openLogin}>Login</button>
              <button className="ghost-button" type="button" onClick={openRegister}>Register</button>
            </>
          )}
          {isAuthenticated && (
            <PublicUserMenu />
          )}
          <Link className="ghost-button" to="/submit-payment">Donate</Link>
          <Link className="solid-button" to="/submit-payment">Submit Payment</Link>
        </div>
        <button
          className="menu-toggle"
          type="button"
          onClick={() => setMobileMenuOpen((prev) => !prev)}
          aria-label="Toggle menu"
          aria-expanded={mobileMenuOpen}
        >
          <span />
          <span />
          <span />
        </button>
      </header>

      <main className="placeholder-main">
        <section className="dashboard-section placeholder-section">
          <div className="placeholder-card">
            <h1>Stories</h1>
            <p>Content will be uploaded soon.</p>
          </div>
        </section>
      </main>

      <footer className="dashboard-footer">
        <div>
          <img className="footer-logo" src={logo} alt="Safco CTG logo" />
          <h3>SFACO-CTG</h3>
          <p>
            Building lifelong connections between graduates, students, and faculty.
          </p>
        </div>
        <div className="footer-links">
          <div>
            <h4>Community</h4>
            <Link to="/contact">Contact</Link>
            <a href="/#events">Events</a>
            <a href="/#chapters">Chapters</a>
          </div>
          <div>
            <h4>Support</h4>
            <a href="/#giving">Giving</a>
            <a href="mailto:alumni@chatar.org">Email us</a>
            <a href="tel:+16175550142">Call office</a>
          </div>
          <div>
            <h4>Resources</h4>
            <Link to="/stories">Newsroom</Link>
            <Link to="/register">Register</Link>
            <Link to="/">Home</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
